import axios from "axios";
import { API_endspoints } from "./API_endspoints";
const Axios = axios.create({
  baseURL: API_endspoints.baseURL,
});

export const API_POST = async (url, data) => {
  let apikey;
  let token;
  let parsedData = JSON.parse(localStorage.getItem("cateringFiestaInfo"));
  if (parsedData) {
    apikey = parsedData?.apikey;
    token = parsedData?.token;
  }
  let uri;
  if (token && apikey) {
    uri = url + "?token=" + token + "&apikey=" + apikey;
  } else {
    uri = url;
  }
  try {
    const res = await Axios.post(uri, data, {
      headers: null,
    });

    return res.data;
  } catch (error) {
    if (error?.status === 401) {
      localStorage.clear();
      window.location.href = "/login";
    } else {
      return error;
    }
  }
};

export const API_GET = async (url) => {
  try {
    let apikey;
    let token;
    let parsedData = JSON.parse(localStorage.getItem("cateringFiestaInfo"));
    if (parsedData) {
      apikey = parsedData?.apikey;
      token = parsedData?.token;
    }
    let uri;
    if (token && apikey) {
      uri = url + "&token=" + token + "&apikey=" + apikey;
    } else {
      uri = url;
    }

    const { data } = await Axios.get(uri, {
      headers: null,
    });

    return data;
  } catch (error) {
    if (error?.status === 401) {
      localStorage.clear();
      window.location.href = "/login";
    } else {
      return error;
    }
  }
};
export const API_GET2 = async (url) => {
  try {
    let apikey;
    let token;
    let parsedData = JSON.parse(localStorage.getItem("cateringFiestaInfo"));
    if (parsedData) {
      apikey = parsedData?.apikey;
      token = parsedData?.token;
    }
    let uri;
    if (token && apikey) {
      uri = url + "?token=" + token + "&apikey=" + apikey;
    } else {
      uri = url;
    }

    const { data } = await Axios.get(uri, {
      headers: null,
    });

    return data;
  } catch (error) {
    if (error?.status === 401) {
      localStorage.clear();
      window.location.href = "/login";
    } else {
      return error;
    }
  }
};
export const API_GET_OPEN = async (url) => {
  try {
    const { data } = await Axios.get(url, {
      headers: null,
    });

    return data;
  } catch (error) {
    if (error?.status === 401) {
      localStorage.clear();
      window.location.href = "/login";
    } else {
      return error;
    }
  }
};
export const API_GET_USERID = async (url, id) => {
  try {
    const token = JSON.parse(localStorage.getItem("cateringFiestaInfo")).token;
    const apikey = JSON.parse(
      localStorage.getItem("cateringFiestaInfo")
    ).apikey;

    const { data } = await Axios.get(
      `${url}?user_id=${id}&token=${token}&apikey=${apikey}`
    );

    return data;
  } catch (error) {
    if (error?.status === 401) {
      localStorage.clear();
      window.location.href = "/login";
    } else {
      return error;
    }
  }
};
export const API_GET_USERID2 = async (url, id) => {
  try {
    const token = JSON.parse(localStorage.getItem("cateringFiestaInfo")).token;
    const apikey = JSON.parse(
      localStorage.getItem("cateringFiestaInfo")
    ).apikey;

    const { data } = await Axios.get(
      `${url}&user_id=${id}&token=${token}&apikey=${apikey}`
    );

    return data;
  } catch (error) {
    if (error?.status === 401) {
      localStorage.clear();
      window.location.href = "/login";
    } else {
      return error;
    }
  }
};
export const API_GET_ID = async (url, id) => {
  try {
    const token = JSON.parse(localStorage.getItem("cateringFiestaInfo")).token;
    const apikey = JSON.parse(
      localStorage.getItem("cateringFiestaInfo  ")
    ).apikey;

    const { data } = await Axios.get(url, {
      params: {
        id: id,
        token: token,
        apikey: apikey,
      },
      headers: {
        // Add any headers you need here
      },
    });

    return data;
  } catch (error) {
    if (error?.status === 401) {
      localStorage.clear();
      window.location.href = "/login";
    } else {
      return error;
    }
  }
};
